{
  "todaysDashboard": {
    "title": "Panel de control"
  },
  "snapshotCards": {
    "needsAction": {
      "title": "Requiere acción",
      "secondaryStat": "{{count}} en curso",
      "breakdown": {
        "urgent": "Liquidar / Transferir",
        "moderate": "Desviación / Sin verificar",
        "aum": "AUM"
      }
    },
    "tradePipeline": {
      "title": "Proceso de Operaciones",
      "secondaryStat": "operaciones pendientes",
      "breakdown": {
        "staged": "Preparadas",
        "approved": "Aprobadas",
        "sent": "Enviadas"
      }
    },
    "opsInFlight": {
      "title": "Operaciones en Curso",
      "secondaryStat": "operaciones",
      "breakdown": {
        "rebalances": "Rebalanceos",
        "batches": "Lotes"
      }
    }
  },
  "tradePipeline": {
    "title": "Proceso de Operaciones",
    "asOfPrefix": "Al",
    "viewTrades": "Ver operaciones →",
    "totalOutstanding": "FLUJO DE OPERACIONES — {{total}} TOTAL PENDIENTE(S)",
    "errorPrefix": "Error:",
    "emptyBar": "No hay operaciones pendientes",
    "staged": {
      "title": "Preparadas",
      "description": "Esperando aprobación"
    },
    "approved": {
      "title": "Aprobadas",
      "description": "Listas para enviar"
    },
    "sent": {
      "title": "Enviadas",
      "description": "Enviadas a los custodios"
    }
  },
  "operations": {
    "activeTitle": "OPERACIONES ACTIVAS ({{count}})",
    "emptyTitle": "No hay operaciones activas",
    "emptyDescription": "Los rebalanceos y lotes de operaciones aparecerán aquí cuando estén en curso",
    "optimizerPortfolios": "{{count}} carteras",
    "bulkTradeRun": "Ejecución de Operaciones Masivas"
  },
  "deepLink": {
    "missingObjectId": "Esta cartera no pudo cargarse completamente — los datos detallados pueden estar incompletos."
  },
  "filters": {
    "searchPortfolios": "Buscar carteras...",
    "searchTickers": "Buscar tickers...",
    "searchModels": "Buscar modelos...",
    "needsRebalance": "Necesita rebalanceo",
    "drift": "Desviación",
    "transfer": "Transferencia",
    "liquidation": "Liquidación",
    "trading": "Operaciones",
    "allTypes": "Todos los tipos",
    "goals": "Objetivos",
    "subAccounts": "Subcuentas",
    "allModels": "Todos los modelos",
    "modelSearchPlaceholder": "Buscar modelos...",
    "clear": "Borrar",
    "rebalanceStarted_one": "Se inició el rebalanceo de {{count}} cartera. Vea el progreso en la pestaña Operaciones Activas.",
    "rebalanceStarted_other": "Se inició el rebalanceo de {{count}} carteras. Vea el progreso en la pestaña Operaciones Activas.",
    "optimizePartialSuccess": "{{succeeded}} de {{total}} optimizaciones iniciadas; {{failed}} fallaron.",
    "optimizeAllFailed": "Todas las optimizaciones fallaron. Por favor, inténtelo de nuevo.",
    "downloadAllSelected": "Descargar Todos los Seleccionados",
    "modelSearchFailed": "La búsqueda de modelos falló. Por favor, inténtelo de nuevo.",
    "portfolioSearchFailed": "La búsqueda de carteras falló. Por favor, inténtelo de nuevo.",
    "exposureSearchFailed": "La búsqueda de tickers falló. Por favor, inténtelo de nuevo.",
    "allStatuses": "Todas las Razones",
    "clearSelection": "Borrar",
    "portfoliosSelected_one": "{{count}} cartera seleccionada",
    "portfoliosSelected_other": "{{count}} carteras seleccionadas",
    "rebalanceSelected": "Rebalancear Seleccionados"
  },
  "portfoliosTable": {
    "pageLoadErrorTitle": "Esta página no se pudo cargar.",
    "pageLoadErrorDescription": "El backend devolvió una violación de no-nulo de GraphQL para una o más filas en la página {{page}}, por lo que se descartó la carga completa de la página. Otras páginas aún podrían funcionar.",
    "retryThisPage": "Reintentar esta página",
    "goBackPage": "Volver una página",
    "noPortfoliosFound": "No se encontraron carteras.",
    "adjustFiltersHint": "Intente ajustar sus filtros.",
    "noDataAvailable": "No hay datos disponibles.",
    "unresolvedRows_one": "{{count}} cartera en esta página no se pudo cargar.",
    "unresolvedRows_other": "{{count}} carteras en esta página no se pudieron cargar.",
    "columns": {
      "portfolio": "Cartera",
      "modelName": "Nombre del Modelo",
      "reason": "Motivo",
      "custodian": "Custodio",
      "advisor": "Asesor",
      "value": "Valor",
      "cashAndPosition": "Efectivo y Posición",
      "lastRebalDate": "Fecha Último Rebalanceo",
      "trades": "Operaciones"
    },
    "custodian": {
      "multiple": "Múltiple"
    },
    "advisor": {
      "multiple": "Múltiple"
    },
    "cashPosition": {
      "cash": "Efectivo",
      "position": "Posición",
      "bandTooltip": "Porcentaje de la banda de desviación de esta cartera, establecido por el motor: {{method}} a ±{{tolerance}}%.",
      "bandTooltipUnavailable": "La banda de desviación para esta cartera no pudo resolverse."
    },
    "tradeToasts": {
      "created_one": "{{count}} operación creada con éxito. Véala en la pestaña Operaciones.",
      "created_other": "{{count}} operaciones creadas con éxito. Véalas en la pestaña Operaciones.",
      "createFailed": "No se pudieron crear las operaciones. Por favor, inténtelo de nuevo.",
      "noActionable": "No hay operaciones procesables — todas las posiciones seleccionadas ya están en o cerca del objetivo.",
      "missingGoalObjectId_one": "{{count}} cartera objetivo se omitió porque falta su ID de cuenta.",
      "missingGoalObjectId_other": "{{count}} carteras objetivo se omitieron porque faltan sus ID de cuenta.",
      "createPartialSuccess": "{{succeeded}} de {{total}} grupos de operaciones creados; {{failed}} fallaron.",
      "createAllFailed": "No se pudieron crear todas las operaciones. Por favor, inténtelo de nuevo.",
      "bucketPartialFailure_one": "{{count}} cartera no pudo agrupar sus nuevas operaciones.",
      "bucketPartialFailure_other": "{{count}} carteras no pudieron agrupar sus nuevas operaciones.",
      "exceedsBuyingPower": "Los montos de compra preparados exceden el poder adquisitivo disponible para una o más carteras."
    }
  },
  "portfoliosTab": {
    "fatalError": "Error al cargar carteras: {{message}}"
  },
  "title": "Centro de Operaciones de Cartera",
  "titleV2": "Centro de Operaciones de Cartera v2",
  "tabs": {
    "dashboard": "Panel de control",
    "portfolios": "Carteras",
    "trades": "Operaciones",
    "activeOperations": "Operaciones Activas"
  },
  "relativeTime": {
    "justNow": "justo ahora",
    "minutesAgo": "hace {{count}}m",
    "hoursAgo": "hace {{count}}h",
    "daysAgo": "hace {{count}}d"
  },
  "insights": {
    "title": "Información",
    "toggleA11y": "Alternar información",
    "sections": {
      "alerts": "Alertas",
      "suggestions": "Sugerencias",
      "info": "Información"
    },
    "driftAlert": {
      "title_one": "{{count}} cartera requiere atención",
      "title_other": "{{count}} carteras requieren atención",
      "description": "El {{percent}}% de las carteras tienen una desviación más allá de la tolerancia, liquidaciones pendientes o rebalanceos de transferencia. Priorice estas antes del final del día.",
      "action": "Ver carteras marcadas"
    },
    "opsActive": {
      "title_one": "{{count}} operación en curso",
      "title_other": "{{count}} operaciones en curso",
      "description": "Los rebalanceos activos o lotes de operaciones están en proceso. Verifique si alguno(s) podría(n) estar atascado(s) en un estado intermedio.",
      "action": "Monitorear operaciones activas"
    },
    "tradesInFlight": {
      "title_one": "{{count}} operación en proceso",
      "title_other": "{{count}} operaciones en proceso",
      "descriptionBulk": "Gran lote de {{count}} operaciones activas. Revise las entradas INICIADAS obsoletas.",
      "descriptionDefault": "Las operaciones están progresando a través del proceso. Verifique si hay entradas bloqueadas u obsoletas.",
      "action": "Ver operaciones en curso"
    },
    "cashFlowRisk": {
      "title_one": "{{count}} salida con riesgo de sobregiro",
      "title_other": "{{count}} salidas con riesgo de sobregiro",
      "description": "Retiros pendientes que exceden el 90% del valor de la cartera. Podrían causar sobregiros o liquidaciones forzadas.",
      "action": "Revisar flujos de efectivo"
    },
    "cashFlowImminent": {
      "title_one": "{{count}} evento de efectivo programado dentro de 24h",
      "title_other": "{{count}} eventos de efectivo programados dentro de 24h",
      "description": "Transferencias programadas para hoy o mañana. Verifique liquidez suficiente y que no haya operaciones en conflicto.",
      "action": "Revisar flujos de efectivo"
    },
    "cashFlowOverview": {
      "title_one": "{{count}} flujo de efectivo pendiente",
      "title_other": "{{count}} flujos de efectivo pendientes",
      "description": "{{inflows}}, {{outflows}}. {{outflowAmount}} salidas pendientes totales. Sin riesgo inmediato.",
      "descriptionInflows_one": "{{count}} entrada",
      "descriptionInflows_other": "{{count}} entradas",
      "descriptionOutflows_one": "{{count}} salida",
      "descriptionOutflows_other": "{{count}} salidas",
      "action": "Ver detalles"
    },
    "allClear": {
      "title": "Todos los sistemas nominales",
      "description_one": "{{count}} cartera dentro de la tolerancia. Sin operaciones activas ni operaciones pendientes.",
      "description_other": "{{count}} carteras dentro de la tolerancia. Sin operaciones activas ni operaciones pendientes."
    },
    "bulkOptimize": {
      "title": "Considerar optimización masiva",
      "description": "{{count}} carteras necesitan rebalanceo sin operaciones activas. Use la selección masiva para optimizar en un solo lote.",
      "action": "Seleccionar carteras"
    },
    "settlementCheck": {
      "title": "Revisar fechas de liquidación",
      "description": "Operaciones en proceso sin operaciones activas. Verifique que las fechas de liquidación sean correctas.",
      "action": "Verificar operaciones"
    },
    "footer": {
      "updatedAt": "Actualizado el {{value}}",
      "refreshA11y": "Actualizar información"
    }
  },
  "bulkTradeRunStates": {
    "GENERATING": "Preparando operaciones...",
    "BULK_TRADES_INITIATED": "Listo para revisión",
    "BULK_TRADES_FILES_GENERATING": "Generando archivos de operaciones...",
    "BULK_TRADES_REQUESTED": "Procesando...",
    "BULK_TRADES_COMPLETED": "Listo para asignar",
    "ALLOCATIONS_INITIATED": "Preparando asignaciones...",
    "ALLOCATIONS_REQUESTED": "Procesando asignaciones...",
    "ALLOCATIONS_COMPLETED": "Asignaciones listas",
    "COMPLETED": "Completado",
    "COMPLETED_PENDING_PTFS": "Operaciones PTF pendientes",
    "CANCELED": "Cancelado"
  },
  "rowDetail": {
    "header": {
      "goalTypeSuffix": " • {{type}}",
      "noModel": "Sin Modelo",
      "subAccountTypeSuffix": " • {{accountType}} (Clasificación Fiscal: {{taxRank}})",
      "multiCcy": "Multidivisa ({{currencies}})",
      "updatedAt": "ACT: {{date}}"
    },
    "generalInfo": {
      "title": "Información General",
      "marketValue": "Valor de Mercado",
      "cash": "Efectivo",
      "targetCash": "Efectivo Objetivo",
      "drift": "Desviación",
      "pending": "Pendiente(s)",
      "holdings": "Posiciones",
      "none": "Ninguno",
      "staleActiveTrades": "0 activas (informe: {{count}} obsoletas)",
      "activeTradesCount": "{{count}} operaciones",
      "driftExceedsThreshold": "Excede el umbral",
      "driftMonitor": "Monitorear",
      "driftWithinTolerance": "Dentro de la tolerancia",
      "positionsCount": "{{count}} posiciones"
    },
    "accountBreakdown": {
      "title": "Desglose de Cuentas ({{count}})",
      "type": "Tipo",
      "client": "Cliente",
      "marketValue": "Valor de Mercado",
      "cashAvailable": "Efectivo Disponible",
      "pendingWithdraw": "Retiro(s) Pendiente(s)"
    },
    "pendingTrades": {
      "title": "Operaciones Pendientes",
      "titleWithCount": "Operaciones Pendientes ({{count}})",
      "side": "Tipo",
      "security": "Valor",
      "amount": "Monto",
      "qty": "Cantidad",
      "state": "Estado",
      "created": "Creada(s)",
      "buyCount_one": "{{count}} Compra",
      "buyCount_other": "{{count}} Compras",
      "sellCount_one": "{{count}} Venta",
      "sellCount_other": "{{count}} Ventas",
      "net": "Neto: {{value}}",
      "noActiveTrades": "No se encontraron operaciones activas",
      "staleCountWarning": "El informe muestra {{count}} pendiente(s) — este recuento está obsoleto. Las operaciones pueden haber sido canceladas, completadas o conciliadas desde la última actualización de la cartera."
    },
    "positions": {
      "title": "Posiciones ({{count}})",
      "symbol": "Símbolo",
      "currency": "Divisa",
      "qty": "Cantidad",
      "price": "Precio",
      "value": "Valor",
      "currentPct": "% Actual",
      "targetPct": "% Objetivo",
      "drift": "Desviación",
      "driftValue": "Desviación $"
    },
    "actions": {
      "viewDetails": "Ver Detalles",
      "generateTrades": "Generar Operaciones"
    }
  },
  "download": {
    "button": "Descargar CSV",
    "all": "Descargar Todo",
    "withFilters": "Descargar con Filtros",
    "filtersTooltip": "Los filtros de búsqueda no están aplicados",
    "progressTitle": "Exportando carteras",
    "fileNamePrefix": "informes-carteras",
    "exportHeaders": {
      "portfolioId": "ID de Cartera",
      "type": "Tipo",
      "modelPortfolio": "Cartera Modelo",
      "marketValue": "Valor de Mercado",
      "cashAvailable": "Efectivo Disponible",
      "targetCashPercent": "% de Efectivo Objetivo",
      "status": "Estado",
      "driftRequired": "Desviación Requerida",
      "pendingTrades": "Operaciones Pendientes",
      "lastOptimized": "Última Optimización"
    }
  },
  "modelPortfolioView": {
    "columns": {
      "model": "Modelo",
      "portfolios": "# de Carteras",
      "marketValue": "Valor Total",
      "avgDrift": "Desviación Promedio",
      "rebalance": "Rebalancear",
      "trades": "Operaciones",
      "currency": "Divisa"
    }
  },
  "tickerView": {
    "columns": {
      "security": "Valor",
      "totalValue": "Valor Total",
      "totalQty": "Cantidad Total",
      "portfolios": "# de Carteras",
      "pctAum": "% de AUM",
      "currency": "Divisa"
    },
    "drilldown": {
      "loading": "Cargando carteras…",
      "loadMore": "Cargar más ({{count}} restantes)",
      "retry": "Reintentar",
      "empty": "No se encontraron carteras para esta posición",
      "error": "No se pudieron cargar las carteras"
    },
    "search": {
      "truncated": "La búsqueda solo cubre los primeros {{max}} tickers de la clasificación actual. Un valor coincidente puede estar fuera de ese rango."
    },
    "tradeResolve": {
      "truncated": "Demasiadas carteras para cargar para la generación de operaciones. Intente con menos tickers o contacte a soporte.",
      "noSelections": "No se encontraron carteras negociables para los tickers seleccionados.",
      "failed": "No se pudieron cargar las carteras para la generación de operaciones."
    }
  },
  "reviewRebalance": {
    "securities": {
      "allocationChange": "{{from}}% → {{to}}%",
      "title": "Valores",
      "emptyState": "No hay operaciones para crear para las carteras seleccionadas. Las posiciones ya están en la asignación objetivo, o las compras no pueden financiarse con el efectivo disponible y los ingresos por ventas.",
      "denominatedIn": "Denominado en {{ccy}}",
      "sentIn": "Enviado en {{ccy}}",
      "approxAtPurchase": "≈ {{amount}} en la compra",
      "removeTradeA11y": "Eliminar operación",
      "columns": {
        "product": "Producto",
        "buys": "Compras",
        "sells": "Ventas",
        "trades": "Operaciones",
        "ticker": "Símbolo Bursátil",
        "ccy": "Divisa"
      },
      "pill_one": "{{count}} símbolo bursátil",
      "pill_other": "{{count}} símbolos bursátiles"
    },
    "title": "Revisar y Rebalancear",
    "subtitle_one": "{{count}} cartera seleccionada",
    "subtitle_other": "{{count}} carteras seleccionadas",
    "closeA11y": "Cerrar panel de revisión",
    "stats": {
      "portfolios": "Carteras",
      "totalTrades": "Total de Operaciones",
      "buySellSubtext": "{{buyCount}} compra · {{sellCount}} venta",
      "buyValue": "Valor de Compra",
      "sellValue": "Valor de Venta",
      "netCashFreed": "Efectivo Neto Liberado"
    },
    "skippedTrades": {
      "title": "Operaciones Omitidas",
      "pill_one": "{{count}} operación omitida",
      "pill_other": "{{count}} operaciones omitidas",
      "description": "Estas operaciones entran en conflicto con solicitudes de operaciones pendientes y no se crearán.",
      "columns": {
        "portfolio": "Cartera",
        "value": "Valor",
        "direction": "Dirección",
        "tradeDate": "Fecha de Operación",
        "status": "Estado",
        "ticker": "Símbolo Bursátil"
      }
    },
    "portfolios": {
      "title": "Carteras",
      "pill_one": "{{count}} en esta ejecución",
      "pill_other": "{{count}} en esta ejecución",
      "columns": {
        "portfolio": "Cartera",
        "model": "Modelo",
        "reason": "Motivo"
      },
      "defaultReason": "Rebalanceo requerido"
    },
    "actions": {
      "cancel": "Cancelar",
      "create_one": "Crear {{count}} operación",
      "create_other": "Crear {{count}} operaciones",
      "creating": "Creando...",
      "checkingConflicts": "Verificando conflictos...",
      "conflictCheckUnavailable": "Verificación de conflictos no disponible",
      "conflictCheckUnavailableMessage": "No se pueden verificar las operaciones en conflicto — la creación está deshabilitada hasta que esto se resuelva."
    }
  }
}
